export default __webpack_public_path__ + "static/media/logo-kids.8d34e43e.svg";